"use strict";

import { h } from "vue";
import { AppstoreOutlined } from "@ant-design/icons-vue";
import { mapGetters } from "vuex";

export default {
  name: "Sidebar",

  data() {
    return {
      menuItems: [
        {
          key: "home",
          label: "Dashboard",
          icon: () => h(AppstoreOutlined),
        },
        {
          key: "members",
          label: "Members",
          icon: () => h(AppstoreOutlined),
        },
        {
          key: "tools",
          label: "Tools",
          icon: () => h(AppstoreOutlined),
        },
        {
          key: "transactions",
          label: "Transactions",
          icon: () => h(AppstoreOutlined),
        },
        {
          key: "masterdata",
          label: "Masterdata",
          icon: () => h(AppstoreOutlined),
          children: [
            {
              key: "products",
              label: "Products",
            },
            {
              key: "users",
              label: "Users",
            },
          ],
        },
      ],

      fMenuItems: [],
    };
  },

  computed: {
    ...mapGetters(["user"]),
  },

  // created() {
  //   if (this.user && this.user.role !== "admin") {
  //     this.fMenuItems = this.menuItems.filter(
  //       (menu) => menu.key !== "settings"
  //     );
  //   } else {
  //     this.fMenuItems = this.menuItems;
  //   }
  // },

  methods: {
    handleClick(value) {
      this.$router.push({ name: value.key });
    },
  },

  watch: {
    user: {
      handler() {
        if (this.user && this.user.role !== "admin") {
          this.fMenuItems = this.menuItems.filter(
            (menu) => menu.key !== "masterdata",
          );
        } else {
          this.fMenuItems = this.menuItems;
        }
      },

      deep: true,
      immediate: true,
    },
  },
};
